import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {InputTextModule} from '../../../../../core/component/input-text/input-text.module';
import {LabelRequiredModule} from '../../../../../../shared/directives/label-required.module';
import {LoadingModule} from '../../../../../../components/common/loading/loading.module';
import {AmountInputModule} from '../../../../../../components/common/amount/amount-input/amount-input.module';
import {SelectModule} from '../../../../../../components/common/select/select.module';
import {DatePickerModule} from '../../../../../../components/common/date-picker/date-picker.module';
import {
    LovValueSelectFilterModule
} from '../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module';
import {
    AccountingAccountSelectFilterModule
} from '../../../../account/api/component/accounting-account-select-filter/accounting-account-select-filter.module';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {PaymentTypeSelectFilterModule} from '../../../../paymentType/payment-type-select-filter/payment-type-select-filter.module';
import {RichTextEditorModule} from '../../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {AccountingMovementCreateFormComponent} from './accounting-movement-create-form.component';
import {BankAccountService} from '../../../../../../services/bank-account/bank-account.service';
import {MovementService} from '../../../../../../services/bank-account/movement.service';
import {CardModule} from "../../../../../core/component/card/card.module";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {
    PaymentCardReaderSelectFilterComponent
} from "../../../../../sale/modules/payment/paymentCardReader/api/component/payment-card-reader-select-filter/payment-card-reader-select-filter.component";
import {MatRadioModule} from "@angular/material/radio";
import {CardV2Component} from "../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        LabelRequiredModule,
        LoadingModule,
        AmountInputModule,
        SelectModule,
        DatePickerModule,
        LovValueSelectFilterModule,
        AccountingAccountSelectFilterModule,
        FormFieldModule,
        PaymentTypeSelectFilterModule,
        RichTextEditorModule,
        InputTextModule,
        CardModule,
        ButtonModule,
        PaymentCardReaderSelectFilterComponent,
        MatRadioModule,
        CardV2Component,
    ],
    declarations: [
        AccountingMovementCreateFormComponent
    ],
    exports: [
        AccountingMovementCreateFormComponent
    ],
    providers: [
        BankAccountService,
        MovementService
    ]
})
export class AccountingMovementCreateFormModule {
}
